<script>
import { imgPathFn } from '@/utils/common'
import { getPageThemeColor } from '@/utils/modules/getStyles'
import { partyBuildingImgPath, imgPath } from '@/utils/filters.js'

export default {
  name: 'TabVertical',
  props: {
    pageData: {
      type: Array,
      default: () => []
    },
    tabActive: {
      type: Number,
      default: 0
    },
    hasImg: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      path: this.$route.path
    }
  },
  methods: {
    imgPathFn, getPageThemeColor,
    onTabClick(id) {
      this.$emit('onTabClick', id)
    },
    tabLogo(idx) {
      const tabLogo = this.$route.path === '/communityIntro'
        ? require('imgs/modules/dialog-modules/tab-logo-green.png')
        : require('imgs/modules/dialog-modules/tab-logo.png')
      return this.tabActive === idx
        ? require('imgs/modules/dialog-modules/tab-logo-active.png')
        : tabLogo
    },
    getColor(i) {
      return this.tabActive === i ? getPageThemeColor(this.path, 0.9) : ''
    },
    getImgURL({ img, typeid }) {
      const firstImg = img.split(',')[0]
      return typeid === 0
        ? partyBuildingImgPath(firstImg)
        : imgPath(img)
    }
  }
}
</script>

<template>
  <div class="tab-container">
    <div
      v-for="(v, i) in pageData"
      :key="`tab-item-${i}`"
      class="tab-item pointer"
      :class="{'active-item': tabActive === i, 'no-img-item': !hasImg}"
      :style="{backgroundColor: getColor(i)}"
      @click="onTabClick(v.id)"
    >
      <el-image
        class="tab-img"
        :src="hasImg ? getImgURL(v) : tabLogo(i)"
        alt="acti"
        fit="cover"
      />
      <p
        class="tab-right"
        :class="[hasImg ? 'h-line-2' : 'h-line-1', {'community-tab-right': v.post}]"
      >{{ v.title }}</p>
      <p v-if="v.post" class="post">{{ v.post || '' }}</p>
      <p class="arrow-fa" :style="{color: getColor(i)}"><i v-show="tabActive === i" class="el-icon-caret-left arrow" /></p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.tab-container {
  width: 295px;
  height: 570px;
  border-radius: 15px;
  border: 3px solid #ededed;
  background-color: #fff;
  padding: 15px 0;
  overflow-y: scroll;
  &::-webkit-scrollbar { // chrome/safari
    display: none;
  }
  scrollbar-width: none; // firefox
  -ms-overflow-style: none; // IE10+
}
.tab-item {
  width: 260px;
  height: 109px;
  box-shadow: 0 0 10 0px rgba(177, 8, 8, 0.06);
  border-radius: 0 15px 15px 0;
  display: flex;
  align-items: center;
  position: relative;
  transition: all ease-in .2s;
  .tab-img {
    flex-shrink: 0;
    width: 85px;
    height: 85px;
    border-radius: 10px;
    margin-left: 10px;
  }
  .tab-right {
    width: 177px !important;
    margin-left: 10px;
    font-size: 16px;
    font-weight: bold;
    color: #000;
    line-height: 23px;
  }
  .community-tab-right {
    width: 110px !important;
  }
  .post {
    // width: 127px;
    margin-left: 10px;
    font-size: 13px;
    color: #60A68F;
    line-height: 23px;
    font-weight: bold;
  }
  .arrow-fa {
    display: block;
    // color: #DD4135;
    font-size: 20px;
    font-weight: bold;
    position: absolute;
    left: 275px;
  }
}

.no-img-item {
  // width: 210px;
  height: 40px;
  background: #EDEDED;
  border-radius: 0 5px 5px 0;
  position: relative;
  // margin-left: 10px;
  .tab-img {
    width: 12px;
    height: 13px;
    border-radius: 0;
  }
  .tab-right {
    width: 90px;
  }
}
.no-img-item:not(:first-child) {
  margin-top: 30px;
}

.active-item {
  // background: #DD4135;
  .tab-right {
    color: #fff;
  }
  .post {
    color: #fff;
  }
}

</style>
